export { default, default as useEmbedInsight } from "./useEmbedInsight";
